/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import { shouldSendBugsnagEvent } from '../global/bugsnagFilters';

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    releaseStage: process.env.MIX_BUGSNAG_APP_ENV,
    onError: shouldSendBugsnagEvent
});

window.calendarLicenseKey = process.env.MIX_FULL_CALENDAR_KEY;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
if (document.getElementById('wrapper')) { // Check for page containing elements
    const app = new Vue({
        el: '#wrapper',
    });
}

window.showError = function (text) {
    bootbox.alert({
        title: 'Error!',
        message: '' + text
    });
};

// For Datatables errors
window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
    if (typeof errorObj !== "undefined") {
        if (errorObj.namespace === "dt") return false;
        else Bugsnag.notify(errorObj);
    }
};

let searchInput = document.getElementById('dashboardSearch'), searchInputButton = document.getElementById('dashboardSearchButton'), searchResults = document.getElementById('dashboardSearchResults');

if (searchInput) {

    let timeoutFunction = null, doSearch = function() {
        searchResults.innerHTML = '';
        searchResults.classList.toggle('d-none', true);

        let searchTerm = searchInput.value;

        axios.post(searchInput.dataset.url, {
            searchTerm: searchTerm
        })
            .then(response => {

                searchResults.classList.toggle('d-none', false);

                if (response.data.length > 0) {

                    for (let resultKey in response.data) {

                        let result = response.data[resultKey];

                        let resultRow = document.createElement('tr');

                        let resultLink = document.createElement('a');
                        resultLink.innerText = result.name;
                        resultLink.href = result.url;

                        resultRow.appendChild(resultLink);

                        searchResults.appendChild(resultRow);
                    }

                } else {

                    let resultRow = document.createElement('tr');

                    resultRow.innerText = 'No results for "' + searchTerm + '"...';

                    searchResults.appendChild(resultRow);

                }

            })
            .catch(errors => {
                console.log(errors);
            });
    };

    searchInput.addEventListener('keyup', function(e) {

        clearTimeout(timeoutFunction);

        timeoutFunction = setTimeout(doSearch, 500);

    });

    searchInputButton.addEventListener('click', function (e) {
        e.preventDefault();

        doSearch();
    })

    window.addEventListener('click', function(e){
        if (!document.getElementById('navbarSearch').contains(e.target)) {
            searchResults.classList.toggle('d-none', true);
        }
    });

}

(function ($) {
    "use strict"; // Start of use strict

    // Toggle the side navigation
    $('#sidebarToggle, #sidebarToggleTop').on('click', function () {
        $('body').toggleClass('sidebar-toggled');
        $('.sidebar').toggleClass('toggled');
        if ($('.sidebar').hasClass('toggled')) {
            $('.sidebar .collapse').collapse('hide');
        }
    });

    // Close any open menu accordions when window is resized below 768px
    $(window).resize(function () {
        if ($(window).width() < 768) {
            $('.sidebar .collapse').collapse('hide');
        }
    });

    // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
    $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
        if ($(window).width() > 768) {
            var e0 = e.originalEvent,
                delta = e0.wheelDelta || -e0.detail;
            this.scrollTop += (delta < 0 ? 1 : -1) * 30;
            e.preventDefault();
        }
    });

    // Scroll to top button appear
    $(document).on('scroll', function () {
        var scrollDistance = $(this).scrollTop();
        if (scrollDistance > 100) {
            $('.scroll-to-top').fadeIn();
        } else {
            $('.scroll-to-top').fadeOut();
        }
    });

    // Smooth scrolling using jQuery easing
    $(document).on('click', 'a.scroll-to-top', function (e) {
        e.preventDefault();

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    $('#dashboardSearch').on('', function(e) {




    });

    // Toasts
    let $toasts = $('#toasts-container #toasts .toast');

    $toasts.on('hidden.bs.toast', function () {
        $(this).remove();
    });

    $toasts.toast('show');

})(jQuery); // End of use strict
